import { Component, ReactElement } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

interface IModalPropsKeys {
  [key: string]: number | (() => void),
}

interface ModalProps extends IModalPropsKeys {
  year: number,
  onHide: () => void,
}

export default class NoDataFoundModalComponent extends Component<ModalProps, never> {
  year: number;

  onHide: () => void;

  constructor(props: ModalProps) {
    super(props);
    this.year = props.year;
    this.onHide = props.onHide;
  }

  render(): ReactElement {
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <Modal {...this.props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Keine Daten für Diagonale {this.year}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Das Filmprogramm wurde anscheinend noch nicht eingespielt &ndash; schau später wieder vorbei! :)
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.onHide}>Okay</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
